// © Microsoft Corporation. All rights reserved.

// TODO: This should be considered for moving it to the Interests experience wrapper, once that
// code arrives, since this is specific to that experience

/**
 * Tab Names
 * @export
 * @type {object}
 */
export const SubnavTabName = {
    Interests: "cinterests",
    MyFeed: "newsfeed",
    XFeed: "xfeed"
};
